export default __webpack_public_path__ + "static/media/wellbeing-yellow.25dd47b4.svg";